import { render } from "./i-terms-acceptance.vue?vue&type=template&id=810ba0b4&scoped=true"
import script from "./i-terms-acceptance.vue?vue&type=script&lang=js"
export * from "./i-terms-acceptance.vue?vue&type=script&lang=js"

import "./i-terms-acceptance.vue?vue&type=style&index=0&id=810ba0b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810ba0b4"]])

export default __exports__